import React, { useState } from "react";
import Webmenu from "../../layouts/webmenu";
import Topbar from "../../layouts/topbar";
import { ThreeDots } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { styleSelect } from "../../constants/customStyles";
import { Link, useNavigate, useParams } from "react-router-dom";
import Select from 'react-select';
import { useEffect } from "react";
import { getAllState } from "../../actions/StateAction";
import { getAllVehicleCode } from "../../actions/VehicleCodeActions";
import DataTable from "react-data-table-component";
import moment from "moment/moment";
import { getAllInsuranceCompany } from "../../actions/InsuranceCompanyActions";
import { getJobCardByInsuranceCompanyId } from "../../actions/JobCardActions";
import Toast from "../../components/Toast";
import { saveBatch } from "../../actions/BatchActions";
import { getBatchById, updateBatch } from "../../actions/BatchActions";
import Mobilemenu from "../../layouts/mobile-menu";

function EditBatch() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();


    const [batchNo, setBatchNo] = useState('');
    const [selectedCompany, setSelectedCompany] = useState('');
    const [selectedJobIds, setSelectedJobIds] = useState([]);

    useEffect(() => {
        dispatch(getAllInsuranceCompany(null, 9999));
        dispatch(getBatchById(params.id));
    }, [])

    const loading = useSelector(state => state?.loading?.addEditLoading);
    const insuranceCompanies = useSelector(state => state?.insuranceCompany?.insuranceCompanies?.data);
    const batch = useSelector(state => state?.batch?.batch);

    useEffect(() => {
        if (batch && Object.keys(batch).length > 0) {
            setBatchNo(batch?.batch_id)
            setSelectedCompany(batch?.insurance_company_id ? { insurance_company_id: batch?.insurance_company_id, name: batch?.insurance_company?.name } : '')
        }
    }, [batch])
    // selectedJobIds);

    const handleChangeCompany = (e) => {
        setSelectedCompany({
            insurance_company_id: e.insurance_company_id,
            name: e.name
        });
        dispatch(getJobCardByInsuranceCompanyId(e.insurance_company_id));
    }

    // const jobCardsByInsuranceCompanyId = useSelector(state => state?.jobCard?.jobCardByInsuranceCompanyId);

    const customStyles = {
        table: {
            style: {
                backgroundColor: 'rgb(241, 245, 248)',
            },
        },
        headRow: {
            style: {
                border: 'none !important'
            }
        },
        head: {
            style: {
                fontWeight: 'bold',
                fontSize: '14px',
                border: 'none !important',
            }
        },
        rows: {
            style: {
                minHeight: '60px', // override the row height
                backgroundColor: '#fff !important',
                borderTop: 'none !important',
                marginBottom: '10px',
                borderRadius: '30px',
                paddingRight: '5px',
                '&:not(:last-of-type)': {
                    border: 'none'
                }
            },
        },
        body: {
            style: {
                backgroundColor: 'rgb(241, 245, 248)',
            }
        },
        headCells: {
            style: {
                paddingLeft: '20px', // override the cell padding for head cells
                paddingRight: '20px',
                fontSize: '14px',
                fontWeight: '700',
                textTransform: 'uppercase',
                border: 'none !important',
                backgroundColor: 'rgb(241, 245, 248)',
                // justifyContent: 'center'
            },
        },
        cells: {
            style: {

                fontSize: '14px',
                // 'div:first-child': {
                //     overflow: 'visible !important'
                // }
                // justifyContent: 'center'
            },
        },
        pagination: {
            style: {
                backgroundColor: 'rgb(241,245,248)',
                borderTop: 'none !important',
            },
        }
    };
    const columns = [
        {
            name: 'JOB NO.',
            selector: row => row.job_card_id,
            sortable: true,
        },
        {
            name: 'CUSTOMER NAME',
            selector: row => row?.job_cards?.customer_name,
            sortable: true,
        },
        {
            name: 'CONTRACTOR NAME',
            selector: row => row?.job_cards?.insurance_company?.name,
            sortable: true,
        },
        {
            name: 'DATE',
            selector: row => row?.job_cards?.date,
            sortable: true,
        },
        {
            name: 'CREATED ON',
            selector: row => moment(row.created_at).format('YYYY-MM-DD'),
            sortable: true,
        },
        // {

        //     cell: row => {
        //         return (<>
        //             <div className="dropdown">
        //                 <button className="dropdown-toggle btn px-2 box text-gray-700 dark-text-gray-300" aria-expanded="false" data-bs-toggle="dropdown">
        //                     <span className="d-flex align-items-center fs-base justify-content-center">
        //                         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-settings me-1 w-6 h-6"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
        //                         Actions
        //                     </span>
        //                 </button>
        //                 <div className="dropdown-menu w-40">
        //                     <div className="dropdown-content">
        //                         <Link className="d-flex align-items-center fs-base py-1" to={`/jobCard/add/${row.estimate_id}`}> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-edit me-1 w-6 h-6"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg> Edit </Link>
        //                         <Link data-bs-target="#document-modal" onClick={(e) => onClickDocumentModal(e, row.job_card_id)} data-bs-toggle="modal" className="d-flex align-items-center fs-base py-1 text-theme-10"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-file me-1 w-6 h-6"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg> Document </Link>
        //                         <Link data-bs-target="#items-modal" onClick={(e) => onClickItemsModal(e, row)} data-bs-toggle="modal" className="d-flex align-items-center fs-base py-1 text-theme-11"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-package me-1 w-6 h-6"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg> Items </Link>
        //                         <Link data-bs-target="#jobOut-modal" onClick={(e) => onClickJobOutModal(e, row)} data-bs-toggle="modal" className="d-flex align-items-center fs-base py-1 text-theme-9"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-square me-1 w-6 h-6"><polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg> Job Out </Link>
        //                         {/* <Link data-bs-target="#document-modal" data-bs-toggle="modal" className="d-flex align-items-center fs-base py-1 text-theme-10"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-file me-1 w-6 h-6"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg> Document </Link> */}
        //                     </div>
        //                 </div>
        //             </div>
        //         </>)
        //     },
        //     width: '300px'
        // },
    ];

    const handleSelectRows = (selectedRows) => {
        setSelectedJobIds(
            selectedRows
        );
    }

    const save = () => {
        if (selectedCompany.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Insurance Company is Required!'
            })
        } else if (batchNo.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Batch No. is Required!'
            })
        } else if (selectedJobIds.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Please Select Jobs!'
            })
        } else {
            let data = {
                batch_no: batchNo,
                insurance_company_id: selectedCompany?.insurance_company_id,
                job_cards: selectedJobIds,
            }
            dispatch(updateBatch(data, params.id, navigate));
        }
        // window.location.href = ('/state');
    }
    return (
        <React.Fragment>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    {
                        loading ?
                            <ThreeDots
                                height="80"
                                width="80"
                                radius="9"
                                color="#2d3748"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                wrapperClassName=""
                                visible={loading}
                            /> :
                            <span>
                                <div className="intro-y d-flex align-items-center mt-5">
                                    <h2 className="fs-lg fw-medium me-auto">
                                        View Batch
                                    </h2>
                                </div>
                                {/* <!-- BEGIN: Form Layout --> */}
                                <div className="intro-y box p-5 mt-5">
                                    <div className="grid columns-12">
                                        <div className="g-col-12 g-col-md-6">
                                            <label for="crud-form-1" className="form-label">Batch No. <span className="text-theme-6">*</span> :</label>
                                            <input id="crud-form-1" disabled value={batchNo} type="text" className="form-control w-full" onChange={(e) => setBatchNo(e.target.value)} placeholder="Enter Batch No." />
                                        </div>
                                        <div className="g-col-12 g-col-md-6">
                                            <label for="crud-form-1" className="form-label">Insurance Company <span className="text-theme-6">*</span> :</label>
                                            <Select
                                                value={selectedCompany}
                                                isDisabled
                                                onChange={(e) => handleChangeCompany(e)}
                                                getOptionLabel={(option) => `${option.name}`}
                                                getOptionValue={(option) => `${option.insurance_company_id}`}
                                                options={insuranceCompanies && insuranceCompanies.length > 0 ? insuranceCompanies : []}
                                                styles={styleSelect}
                                                name=""
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="intro-y g-col-12">
                                    <div className='mt-2'>
                                        <DataTable
                                            className="overflow-lg-visible"
                                           columns={columns.map(column => ({
                                                    ...column,
                                                    cell: column.cell ? column.cell : (row) => (
                                                        <div>
                                                            {column.selector(row)}
                                                        </div>
                                                    ),
                                                }))}
                                            data={batch?.batch_detail && batch?.batch_detail.length > 0 ? batch?.batch_detail : []}
                                            striped={true}
                                            highlightOnHover={true}
                                            pagination={false}
                                            // selectableRows={true}
                                            customStyles={customStyles}
                                            responsive={true}
                                        // onSelectedRowsChange={(e) => handleSelectRows(e.selectedRows)}
                                        />
                                    </div>
                                </div>
                                <div className="text-end mt-5">
                                    <button type="button" onClick={() => navigate('/batch')} className="btn btn-outline-secondary bg-white w-24 me-1">Back</button>
                                    {/*  <button onClick={save} type="button" disabled={loading ? true : false} className="btn btn-primary w-24 ms-2">Save</button> */}
                                </div>
                            </span>
                    }
                </div>
            </div>
        </React.Fragment>
    )
}
export default EditBatch;